/**
 * KAN-851: фильтр списка приложения менеджера по теплоте лида (чипы
 * Все / Горячие / Тёплые / Прохладные / Ледяные), на клиенте: список уже загружен целиком.
 */
import { useMemo, useState } from 'react';
import { filterByLeadTemperature, type LeadTemperatureFilter } from '@/lib/leadTemperature';

export interface LeadTemperatureFilterState<T> {
  filter: LeadTemperatureFilter;
  setFilter: (filter: LeadTemperatureFilter) => void;
  filtered: T[];
}

export function useLeadTemperatureFilter<T>(
  items: readonly T[],
  levelOf: (item: T) => string | null | undefined
): LeadTemperatureFilterState<T> {
  const [filter, setFilter] = useState<LeadTemperatureFilter>('all');
  const filtered = useMemo(() => filterByLeadTemperature(items, filter, levelOf), [items, filter, levelOf]);
  return { filter, setFilter, filtered };
}
